import { render, staticRenderFns } from "./IndexxPage2.vue?vue&type=template&id=062c5c5b&scoped=true"
import script from "./IndexxPage2.vue?vue&type=script&lang=js"
export * from "./IndexxPage2.vue?vue&type=script&lang=js"
import style0 from "./IndexxPage2.vue?vue&type=style&index=0&id=062c5c5b&prod&scoped=true&lang=css"
import style1 from "./IndexxPage2.vue?vue&type=style&index=1&id=062c5c5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f1c606d12331ca9397f00d9371f47138/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062c5c5b",
  null
  
)

export default component.exports